import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('offgrid');
    const { locale } = useRouter();

    return (
        <div className={`off-grid-A ${css['off-grid-A']}`}>
            <div className="img-box">
                <EFPicture
                    src={'/responsive/picture/off-grid/1.jpg'}
                    srcPad={'/responsive/picture/off-grid/1_768.jpg'}
                    srcMobile={'/responsive/picture/off-grid/1_768.jpg'}
                    alt={t('secA_title')}
                />
            </div>
            <div className="text-info">
                <h1 className="title">{t('secA_title')}</h1>
                <p className="desc sub">{t('secA_desc')}</p>
                <a className="btn" href="#off-grid-B">
                    {t('secA_btn')}
                </a>
            </div>
        </div>
    );
}
